import { Spin } from 'antd';
import styled from 'styled-components';

const LoadingSpinner = styled(Spin)``;

export default LoadingSpinner;
